/* eslint-disable max-len */
import ClKitsOrderSuccess from 'components/cl-kits-order-success';
import ClRefundOrderSuccess from 'components/cl-refund-order-success';
import OrderSuccess from 'components/order-success';
import RtiDealerRefundOrderSuccess from 'components/rti-dealer-refund-order-success';
import Spinner from 'components/spinner';
import {autobind} from 'core-decorators';
import addressesQuery from 'graphql/queries/addresses.gql';
import bagsQuery from 'graphql/queries/bags.gql';
import creditsQuery from 'graphql/queries/credits.gql';
import orderQuery from 'graphql/queries/order.gql';
import ordersQuery from 'graphql/queries/orders.gql';
import signsQuery from 'graphql/queries/signs.gql';
import userQuery from 'graphql/queries/user.gql';
import React, {Component} from 'react';
import {compose, graphql} from 'react-apollo';
import ErrorPage from 'views/error-page';

export const refundForm = (mutation, options = {}) => Wrapped => {
    @compose(
        graphql(mutation, {
            props: ({mutate}) => ({
                onSubmit: variables => mutate({
                    variables,
                    refetchQueries: [{query: ordersQuery}, {query: creditsQuery}],
                }),
            }),
        }),
        graphql(addressesQuery, {
            name: 'addressesData',
            skip: !options.loadAddresses,
            options: {
                fetchPolicy: 'network-only',
            },
        }),
    )
    @autobind
    class RefundForm extends Component {
        state = {};

        populateInitial(fields) {
            const {returnData = {}} = this.props.location.state || {};
            return fields.map(field => ({
                ...field,
                initial: returnData[field.key] || field.initial,
            }));
        }

        getLocalitySelectProps({value: selectedOption, onChange, onBlur}) {
            return {
                value: selectedOption && selectedOption.id,
                onChange: (value, option) => onChange(option),
                onBlur,
            };
        }

        async handleSubmit(values) {
            this.setState({loading: true, errors: undefined});
            const mainKeys = ['estimatedAmount', 'address', 'singBudget', 'singLogo'];
            const variables = {};
            const extraData = {};
            Object.entries(values).forEach(([key, value]) => {
                if (mainKeys.includes(key)) {
                    if (key === 'singBudget' || key === 'singLogo') {
                        const [file] = value;
                        variables[key] = file;
                    } else {
                        variables[key] = value;
                    }
                } else extraData[key] = value;
            });

            const response = await this.props.onSubmit({
                ...variables,
                extraData: JSON.stringify(extraData),
            });

            if (response.data.createOrder.errors) {
                this.setState({
                    loading: false,
                    errors: response.data.createOrder.errors,
                });
            } else {
                this.setState({
                    loading: false,
                    orderId: response.data.createOrder.order.id,
                });
            }
        }

        render() {
            if (this.props.addressesData && this.props.addressesData.loading) return <Spinner />;
            if (this.state.orderId) {
                if (this.props.history.location.pathname === '/campo-lider-distribuidor/presupuesto/') {
                    return (
                        <ClRefundOrderSuccess
                            title='¡Pedido realizado exitosamente!'
                            orderId={this.state.orderId}
                        />
                    );
                } else if ((this.props.history.location.pathname === '/campo-lider-distribuidor/kits/')) {
                    return (
                        <ClKitsOrderSuccess
                            title='¡Pedido realizado exitosamente!'
                            orderId={this.state.orderId}
                        />
                    );
                } else if ((this.props.history.location.pathname === '/rti-distribuidor/presupuesto/')) {
                    return (
                        <RtiDealerRefundOrderSuccess
                            title='¡Pedido realizado exitosamente!'
                            orderId={this.state.orderId}
                        />
                    );
                }
                return (
                    <OrderSuccess
                        title='¡Pedido realizado exitosamente!'
                        orderId={this.state.orderId}
                    />
                );
            }

            return (
                <Wrapped
                    {...this.props}
                    {...this.state}
                    onSubmit={this.handleSubmit}
                    populateInitial={this.populateInitial}
                    getLocalitySelectProps={this.getLocalitySelectProps}
                />
            );
        }
    }

    return RefundForm;
};

const createItemsForm = itemsQuery => (mutation, orderCategory) => Wrapped => {
    @compose(
        graphql(addressesQuery, {
            name: 'addressesData',
            options: {
                fetchPolicy: 'network-only',
            },
        }),
        graphql(itemsQuery, {
            name: 'itemsData',
            options: () => ({variables: {orderCategory}}),
        }),
        graphql(mutation, {
            props: ({mutate}) => ({
                onSubmit: variables => mutate({
                    variables,
                    refetchQueries: [{query: ordersQuery}],
                }),
            }),
        }),
    )
    @autobind
    class ItemsForm extends Component {
        state = {
            productSelected: false,
        };

        componentWillMount() {
            this.props.history.replace({
                ...this.props.history.location,
                state: {},
            });
        }

        populateInitial(fields) {
            const {returnData = {}} = this.props.location.state || {};
            return fields.map(field => ({
                ...field,
                initial: returnData[field.key] || field.initial,
            }));
        }

        toggleSelectedProduct() {
            this.setState({productSelected: !this.state.productSelected});
        }

        async submitForm(values) {
            this.setState({loading: true, errors: undefined});

            const main = ['items', 'address'];
            const variables = {};
            const extra = {};

            Object.entries(values).forEach(([key, value]) => {
                if (main.includes(key)) variables[key] = value;
                else extra[key] = value;
            });

            const response = await this.props.onSubmit({
                ...variables,
                extraData: JSON.stringify(extra),
            });

            if (response.data.createOrder.errors) {
                this.setState({
                    loading: false,
                    errors: response.data.createOrder.errors,
                });
            } else {
                this.setState({
                    loading: false,
                    orderId: response.data.createOrder.order.id,
                });
            }
        }

        handleSubmit(values) {
            if (this.state.productSelected) {
                if (
                    window.confirm('Seleccionaste un producto pero aún no lo agregaste. ¿Deseás continuar de todos modos?')
                ) { this.submitForm(values); }
            } else this.submitForm(values);
        }

        render() {
            const {addressesData, itemsData} = this.props;
            if (addressesData.loading || itemsData.loading) return <Spinner />;
            if (this.state.orderId) {
                return (
                    <OrderSuccess
                        title='¡Pedido realizado exitosamente!'
                        orderId={this.state.orderId}
                    />
                );
            }

            return (
                <Wrapped
                    {...this.props}
                    {...this.state}
                    onSubmit={this.handleSubmit}
                    populateInitial={this.populateInitial}
                    toggleSelectedProduct={this.toggleSelectedProduct}
                />
            );
        }
    }

    return ItemsForm;
};

export const bagForm = createItemsForm(bagsQuery);
export const signForm = createItemsForm(signsQuery);

const modifyItemsForm = itemsQuery => (mutation, orderCategory) => Wrapped => {
    @compose(
        graphql(userQuery, {name: 'userData'}),
        graphql(orderQuery, {
            name: 'orderData',
            options: (ownProps) => ({
                variables: {
                    id: ownProps.match.params.id,
                },
            }),
        }),
        graphql(addressesQuery, {
            name: 'addressesData',
            skip: ({orderData}) => !orderData.order,
            options: ({orderData}) => ({
                fetchPolicy: 'network-only',
                variables: {
                    organization: orderData.order.organization.id,
                },
            }),
        }),
        graphql(itemsQuery, {
            name: 'itemsData',
            skip: ({orderData}) => !orderData.order,
            options: ({orderData}) => ({variables: {
                orderCategory,
                organization: orderData.order.organization.id,
            }}),
        }),
        graphql(mutation, {
            props: ({mutate, ownProps}) => ({
                onSubmit: variables => mutate({
                    variables,
                    refetchQueries: [
                        {query: ordersQuery},
                        {
                            query: orderQuery,
                            variables: {id: ownProps.match.params.id},
                        },
                    ],
                }),
            }),
        }),
    )
    @autobind
    class ModifyItemsForm extends Component {
        state = {
            productSelected: false,
        };

        toggleSelectedProduct() {
            this.setState({productSelected: !this.state.productSelected});
        }

        async submitForm(values) {
            this.setState({loading: true, errors: undefined});

            const main = ['reason', 'address', 'items'];
            const variables = {};
            const extra = {};

            Object.entries(values).forEach(([key, value]) => {
                if (main.includes(key)) variables[key] = value;
                else extra[key] = value;
            });

            const response = await this.props.onSubmit({
                ...variables,
                order: this.props.orderData.order.id,
                category: this.props.orderData.order.category.id,
                extraData: JSON.stringify(extra),
            });

            if (response.data.modifyOrder.errors) {
                this.setState({
                    loading: false,
                    errors: response.data.modifyOrder.errors,
                });
            } else {
                this.setState({
                    loading: false,
                    success: true,
                });
            }
        }

        handleSubmit(values) {
            if (this.state.productSelected) {
                if (
                    window.confirm('Seleccionaste un producto pero aún no lo agregaste. ¿Deseás continuar de todos modos?')
                ) { this.submitForm(values); }
            } else this.submitForm(values);
        }

        render() {
            const {userData, orderData, addressesData, itemsData} = this.props;
            if (userData.loading || orderData.loading || addressesData.loading || itemsData.loading) return <Spinner />;

            if (!orderData.order.isModifiable) return <ErrorPage status={404} />;

            if (this.state.success) {
                return (
                    <OrderSuccess
                        title='¡Pedido modificado exitosamente!'
                        orderId={orderData.order.id}
                    />
                );
            }

            return (
                <Wrapped
                    {...this.props}
                    {...this.state}
                    addressesData={addressesData}
                    orderData={orderData}
                    toggleSelectedProduct={this.toggleSelectedProduct}
                    onSubmit={this.handleSubmit}
                />
            );
        }
    }

    return ModifyItemsForm;
};

export const modifyBagsForm = modifyItemsForm(bagsQuery);
export const modifySignsForm = modifyItemsForm(signsQuery);



// WEBPACK FOOTER //
// ./components/forms/decorators.js